/* eslint-disable react-hooks/exhaustive-deps */
// React
import { useEffect, useState } from "react";

// Router
import { useNavigate } from "react-router-dom";

// Redux
import { useDispatch, useSelector } from "react-redux";

import { getSpecificUser } from "../../../redux/features/Settings/Management/Users";

// Components
import CategorySelector from "../../_utils/TransactionCommonComponents/CategorySelector";
import SourceDestinationAccountDetail from "../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";

import "./index.css";
import { viewAccountDetail } from "../../../redux/features/accounts/ReimburseAccount";
import CommonLayout from "../../_utils/CommonLayout";

const ReimbursementRequestAccount = (props) => {
  //  useNavigate, useDispatch
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //  useState
  const [loading, setLoading] = useState(
    props?.txnPayLoad?.beneAccountId?.length ? false : true,
  );
  const [isError, setIsError] = useState(false);

  const [beneAccountId, setBeneAccountId] = useState(
    props?.txnPayLoad?.beneAccountId ? props?.txnPayLoad?.beneAccountId : null,
  );

  const { beneTxnAccountData } = useSelector(
    (state) => state?.beneTxnViewAccData,
  );

  //  Constants
  const disableCategories = true;
  const unassignCategories = props?.categories.filter(
    (cat) => cat?.active === "Y",
  );
  const unassignlength = unassignCategories.filter(
    (unassignCategory) => !props?.category?.includes(unassignCategory.name),
  );

  //  Callbacks
  const fetch = async () => {
    if (!props?.txnPayLoad?.beneAccountId?.length) {
      const id = JSON.parse(sessionStorage.getItem("response"))?.employees?.id;
      let response = await dispatch(getSpecificUser(id));

      if (
        response?.payload?.employees?.[0]?.register_accounts
          ?.reimbursement_accounts?.beneficiary_account_id
      ) {
        let data = await dispatch(
          viewAccountDetail({
            id: response?.payload?.employees?.[0]?.register_accounts
              ?.reimbursement_accounts?.beneficiary_account_id,
          }),
        );

        handleAccountSelection(
          data?.payload?.reimbursement_accounts?.[0]?.name,
          data?.payload?.reimbursement_accounts?.[0]?.bank_acc_no,
          data?.payload?.reimbursement_accounts?.[0]?.ifsc_code,
          data?.payload?.reimbursement_accounts?.[0]?.ifsc_code,
          data?.payload?.reimbursement_accounts?.[0]?.category,
          data?.payload?.reimbursement_accounts?.[0]?.pan_no,
          data?.payload?.reimbursement_accounts?.[0]?.id,
          data?.payload?.reimbursement_accounts?.[0]?.labels,
        );

        setLoading(false);
      } else {
        setIsError(true);
        setLoading(false);
      }
    }
  };

  //  useEffect
  useEffect(() => {
    fetch();
  }, []);

  const handleUnassignNavigate = (id) => {
    navigate(
      `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/edit_category/${id}`,
    );
  };

  const handleCloseModal = () => {
    props?.setIsModalOpen(false);
  };

  const handleAccountSelection = (
    accountName,
    accountNumber,
    ifsc,
    bankLogo,
    category,
    panNo,
    beneAccountId,
    labels,
  ) => {
    const categoriesArray = category?.split(",");
    props?.setCategory(categoriesArray);
    // setAccountName(accountName);
    // setBankLogo(bankLogo);
    setBeneAccountId(beneAccountId);
    // setPanNumber(panNo);
    props?.setLabelsAcc(labels);

    props?.setTxnPayLoad((prev) => ({
      ...prev,
      bankAccountName: accountName,
      beneAccountId: beneAccountId,
      bankAccountIFSC: ifsc,
      bankAccountNo: accountNumber,
      bankLogo: bankLogo,
      pan: panNo,
      labels: labels,
      mergeCategory: null,
    }));
    props?.setAmountInWords("");
    handleCloseModal();
  };

  const handleCategorySelect = (category) => {
    const categoryData = props?.categories.find(
      (cat) =>
        cat.name?.trim().toLowerCase() === category?.trim().toLowerCase(),
    );
    if (props?.selectedCategory?.name === category) {
      return;
    }
    if (props?.txnPayLoad?.selectedCategory?.name === props?.catName) {
      props?.setCatSelect(false);
    }
    props?.setSelectedCategory(categoryData);
    props?.handleCategorySelect(categoryData);
    props?.setTxnPayLoad({
      ...props?.txnPayLoad,
      selectedCategory: categoryData,
    });
    props?.setAdditionalData({});
    props?.setSelectedValue({ from: "Select", to: "Select" });
    props?.setStartDate({});
    props?.setEndDate({});
    props?.setStartDateCal({});
    props?.setIsSingleDateSelected(false);
    props?.setHyperLink({});
    props?.setPreviewImages({});
    props?.setUploadedFiles({});
    props?.setTimeData({});
    props?.setQuantities({});
    props?.setSelectedValueMonth({});
  };

  useEffect(() => {
    if (props?.mapingCat === "renderCat" && props?.catSelect) {
      handleCategorySelect(beneTxnAccountData?.transaction?.[0]?.category);
      props?.setMapingCat(null);
    }
  }, [props?.mapingCat, props?.catSelect]);

  return (
    <>
      {loading ? (
        <div className="h-full w-full flex justify-center items-center">
          <img
            src="https://q2pay.in/new_assets/gifs/inputloader_white.gif"
            alt="loader"
            className="w-loader-md h-loader-md"
          />
        </div>
      ) : (
        <div className="w-width-full Qlg:px-padding-base px-padding-md Qsmd:pt-padding-lg pt-padding-md">
          <CommonLayout>
            <div
              className={`w-width-full lg:max-w-[var(--create-box-width)] items-stretch `}
            >
              {isError ? (
                <div className="p-padding-md flex items-center bg-emphasis rounded-border-radius-md mb-margin-md">
                  <div className="flex items-center gap-x-gap-sm">
                    <img
                      className="h-icon-md w-icon-md flex-shrink-0"
                      src="https://q2pay.in/new_assets/common/settings/error_with_white_circle.svg"
                      alt="error"
                    />
                    <p className="text-text-primary text-font-sm font-normal">
                      No reimbursement account is linked to your user. Link an
                      account to create a request.
                    </p>
                  </div>
                </div>
              ) : null}
              <SourceDestinationAccountDetail
                type="destination"
                flow="beneficiary"
                modalOpen={props?.isModalOpen}
                setModalOpen={props?.setIsModalOpen}
                txnPayLoad={props.txnPayLoad}
                setTxnPayLoad={props.setTxnPayLoad}
                shouldShowAssociatedAccounts={false}
                handleOnAccountSelection={handleAccountSelection}
                isDisabled={isError ? true : false}
                isEditDisabled={true}
                isReimbursement={true}
              />
            </div>
            <div className="w-width-full lg:max-w-[var(--create-box-width)] pb-padding-xl">
              {isError ? null : (
                <CategorySelector
                  beneAccountId={beneAccountId}
                  category={props?.category}
                  selectedCategory={props?.selectedCategory}
                  unassignCategories={unassignCategories}
                  unassignlength={unassignlength}
                  disableCategories={disableCategories}
                  handleCategorySelect={handleCategorySelect}
                  handleUnassignNavigate={handleUnassignNavigate}
                  previewMode={false}
                  enableSearch={true}
                  showUnassignCTA={true}
                />
              )}
            </div>
          </CommonLayout>

          <div className="h-mobile-create-header w-width-full Qmd:hidden block mt-margin-md"></div>
        </div>
      )}
    </>
  );
};

export default ReimbursementRequestAccount;
